import { Image, UIHeading4, Body2 } from '@cian/ui-kit';
import * as React from 'react';
import styles from './OfferCard.css';
import { IUserProfileRecentlyWatchedOffer } from '../../../../../../../types/userProfile';

interface IProps {
  offer: IUserProfileRecentlyWatchedOffer;
}

export const OfferCard = (props: IProps) => {
  const { offer } = props;
  const { url, price, specs, location, imageUrl } = offer;

  return (
    <a href={url} className={styles['wrapper']} target="_blank" rel="noreferrer" data-testid="UserCardOfferCard">
      <div className={styles['image']}>
        <Image src={imageUrl} objectFit="cover" borderRadius="0" alt="" />
      </div>
      <div className={styles['info']}>
        {price && <UIHeading4>{price}</UIHeading4>}
        {specs && <Body2>{specs}</Body2>}
        {location && <Body2 color="text-secondary-default">{location}</Body2>}
      </div>
    </a>
  );
};
